export const CMS_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
} as const;

export const isActiveCmsStatus = (status?: string | null) =>
  status?.toLowerCase() === CMS_STATUS.ACTIVE;

export const getCmsToggleStatus = (status?: string | null) =>
  isActiveCmsStatus(status) ? CMS_STATUS.INACTIVE : CMS_STATUS.ACTIVE;

export const normalizeCmsFormStatus = (status: unknown) => {
  if (typeof status !== "string") return status;
  const normalized = status.trim().toLowerCase();
  if (normalized === CMS_STATUS.INACTIVE) return CMS_STATUS.INACTIVE;
  if (normalized === CMS_STATUS.ACTIVE) return CMS_STATUS.ACTIVE;
  return status;
};

export const CONTENT_PATH = "/apps/content";

export const EDUCATIONAL_CONTENT_PATH = `${CONTENT_PATH}/educational`;
export const FEATURED_CONTENT_PATH = `${CONTENT_PATH}/featured`;
export const LEGAL_PAGES_PATH = `${CONTENT_PATH}/legal`;
export const FAQ_PATH = `${CONTENT_PATH}/faq`;
